import React, { useCallback, useMemo, useRef } from "react";
import { View } from "react-native";
import { InputField } from "@lookiero/aurora";
import { useI18nMessage, useI18n } from "@lookiero/i18n-react";
import { I18nMessages } from "../../../../../i18n/i18n";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { useAnswersValidation } from "../../behaviours/useAnswersValidation";
import { useQuestionValidationError } from "../../behaviours/useQuestionValidationError";
const HostSelectQuestionItem = ({ domain, question, segment }) => {
    const { formatMessage } = useI18n({ domain });
    const emptyOptionText = useI18nMessage({
        domain,
        id: I18nMessages.HOST_SELECT_EMPTY_OPTION,
        values: { segment: segment.toLowerCase() },
    });
    const label = useI18nMessage({ domain, id: question.translationKey, values: { segment: segment.toLowerCase() } });
    const { answer, onChange } = useAnswerForId({ id: question.id });
    const selectedAnswer = answer && answer[0];
    const ref = useRef(null);
    const validationError = useQuestionValidationError({ domain, questionId: question.id, ref, segment });
    const { validateMaxAnswers } = useAnswersValidation();
    const handleOnChange = useCallback((value) => {
        onChange({ questionId: question.id, answer: value });
        validateMaxAnswers();
    }, [onChange, question.id, validateMaxAnswers]);
    const options = useMemo(() => question.children.map((option) => ({
        name: formatMessage({ id: option.translationKey }, { segment: segment.toLowerCase() }),
        value: option.id,
    })), [formatMessage, question.children, segment]);
    return (React.createElement(View, { ref: ref, testID: "host-select-question-item" },
        React.createElement(InputField, { emptyOptionText: emptyOptionText, error: Boolean(validationError), icon: "arrow_down", label: label, name: label, options: options, testID: "host-select-question-item-input", value: selectedAnswer, 
            // @ts-ignore
            onChange: handleOnChange })));
};
export { HostSelectQuestionItem };
